import { DirectiveBinding } from 'vue/types/options.d';
import { IpcEvents } from '@/ipc-events';
import ipc from '@/renderer/scripts/utils/ipc';
class IsAble {
  perValue: boolean;
  constructor() {
    this.perValue = false;
  }
  get value(): boolean {
    return this.perValue;
  }

  /**
   * 不直接赋值而通过 set 的作用是：
   *    允许 <div v-doubleClickToMaxWin />
   *    而不必 <div v-doubleClickToMaxWin="isAble" />
   */
  set value(value) {
    if (typeof value === 'undefined') {
      this.perValue = true;
    } else if (typeof value === 'boolean') {
      this.perValue = value;
    }
  }
}
const isAble = new IsAble();

/**
 * 监听器函数
 * 在下文中被绑定
 */
const listener = () => {
  if (isAble.value) {
    ipc.send(IpcEvents.ON_OPERATE_MAIN_LISTENER, {
      event: 'winMaxSwitch',
    });
  }
};

/**
 * v-doubleClickToMaxWin
 * @desc 双击元素放大窗口
 * @example
 * ```vue
 * <div v-doubleClickToMaxWin="isAble" />
 * <div v-doubleClickToMaxWin /> 默认为true
 * ```
 */
export default {
  /**
   * 指令绑定到元素时：
   * 1. 更新 isAble 变量
   * 2. 绑定监听器
   */
  bind(el: HTMLElement, binding: DirectiveBinding): void {
    isAble.value = binding.value;
    el.addEventListener('dblclick', listener);
  },
  /**
   * 元素 VNode 更新时：更新 isAble 变量
   */
  update(el: HTMLElement, binding: DirectiveBinding): void {
    isAble.value = binding.value;
  },
  /**
   * 指令与元素解绑时：注销监听器
   */
  unbind(el: HTMLElement): void {
    el.removeEventListener('dblclick', listener);
  },
};
